import CmtCard from "@coremat/CmtCard";
import CmtCardContent from "@coremat/CmtCard/CmtCardContent";
import React from "react";
import MediaUploader from "../Uploader";
import MediaList from "../List";
import { Dialog } from "@material-ui/core";
import { DialogTitle, DialogContent } from "../List/EditMediaModalUtils";

const FileUploader = ({
  selectMode,
  open,
  handleClose,
  handleSelect,
  gallerySlected,
  handleSelectGallery,
  selectedItem,
  imageSelector,
  gallerySelctor,
}) => {
  return selectMode ? (
    <Dialog
      fullWidth={true}
      maxWidth={"lg"}
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogTitle id="mediaDialogTitle" onClose={handleClose} />
      <DialogContent>
        <MediaUploader />
        <MediaList
          selectMode={true}
          handleSelect={handleSelect}
          selectedItem={selectedItem}
          imageSelector={imageSelector}
          gallerySelctor={gallerySelctor}
          handleClose={handleClose}
          gallerySlected={gallerySlected}
          handleSelectGallery={handleSelectGallery}
        />
      </DialogContent>
    </Dialog>
  ) : (
    <CmtCard>
      <CmtCardContent sx={{ pb: 0 }}>
        <MediaUploader />
        <MediaList />
      </CmtCardContent>
    </CmtCard>
  );
};

export default FileUploader;
